unit unit_SupportKonto;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  WEBLib.Grids, DB;

type
  TSupportKonto = class(TForm)
    TC: TTableControl;
    xdsKontoSaldo: TXDataWebDataSet;
    xdsKontoSaldoKundennummer: TStringField;
    xdsKontoSaldoZeitaufwand: TIntegerField;
    xdsKontoSaldoAbzurechnen: TIntegerField;
    xdsKontoSaldoGutschrift: TIntegerField;
    xdsKontoSaldoAbzug: TIntegerField;
    xdsKontoSaldoSaldo: TIntegerField;
    xdsKontoSaldoBetrag: TFloatField;
    xdsKontoSaldoMinutenpreis: TFloatField;
    xdsKontoSaldoSRestguthaben: TIntegerField;
    xdsKontoBewegungen: TXDataWebDataSet;
    xdsKontoBewegungenID: TIntegerField;
    xdsKontoBewegungenKundennummer: TStringField;
    xdsKontoBewegungenBuchungsart: TStringField;
    xdsKontoBewegungenLizenzID: TIntegerField;
    xdsKontoBewegungenTicketID: TIntegerField;
    xdsKontoBewegungenDatum: TDateTimeField;
    xdsKontoBewegungenZeitaufwand: TIntegerField;
    xdsKontoBewegungenAbzurechnen: TIntegerField;
    xdsKontoBewegungenGutschrift: TIntegerField;
    xdsKontoBewegungenAbzug: TIntegerField;
    xdsKontoBewegungenBetrag: TFloatField;
    xdsKontoBewegungenSaldo: TIntegerField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsKontoSaldoAfterOpen(DataSet: TDataSet);
    procedure xdsKontoBewegungenAfterOpen(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    buttonzurueck:TButton;
    procedure buttonzurueckclick(Sender:TObject);
    procedure FormularAnzeigen;
  protected procedure LoadDFMValues; override; end;

var
  SupportKonto: TSupportKonto;

implementation
  uses unit1, unit2;
{$R *.dfm}

procedure TSupportKonto.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TSupportKonto.FormularAnzeigen;
var
  i:integer;
  myelement:TJSHTMLElement;
  tmpsaldo:double;
begin
  tmpsaldo:=0;
  TC.ColCount:=3;
  tc.RowCount:=xdsKontoBewegungen.recordcount+6;

  tc.Cells[0,0]:='<h5>Ihr Supportkonto';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='<b>Restguthaben: '+xdsKontoSaldoSRestguthaben.AsString;
  inc(i);
  tc.Cells[0,i]:='<b>Buchungen';
  tc.Cells[1,i]:='<b>Minuten';
  tc.Cells[2,i]:='<b>lfd.Summe';
  while not xdsKontoBewegungen.eof do
  begin
    inc(i);
    if xdsKontoBewegungenBuchungsart.AsString='Ticket' then
    begin
      tc.Cells[0,i]:=formatdatetime('DD.MM.YYYY - ',xdsKontoBewegungenDatum.Asdatetime)+' '+xdsKontoBewegungenBuchungsart.AsString+'-Nr.: '+xdsKontoBewegungenTicketID.AsString;
    end;
    if xdsKontoBewegungenBuchungsart.AsString='Paket' then
    begin
      tc.Cells[0,i]:=formatdatetime('DD.MM.YYYY - ',xdsKontoBewegungenDatum.Asdatetime)+' Einbuchung Supportpaket';
    end;
    if xdsKontoBewegungenBuchungsart.AsString='Supportkauf' then
    begin
      tc.Cells[0,i]:=formatdatetime('DD.MM.YYYY - ',xdsKontoBewegungenDatum.Asdatetime)+' Einbuchung Supportkauf';
    end;
    if xdsKontoBewegungenBuchungsart.AsString='Servicepauschale' then
    begin
      tc.Cells[0,i]:=formatdatetime('DD.MM.YYYY - ',xdsKontoBewegungenDatum.Asdatetime)+' Monatliche Servicepauschale';
    end;
    tc.Cells[1,i]:=xdsKontoBewegungenSaldo.AsString;
    tmpsaldo:=tmpsaldo+xdsKontoBewegungenSaldo.AsFloat;
    tc.Cells[2,i]:=floattostr(tmpsaldo);
    xdsKontoBewegungen.Next;
  end;
end;

procedure TSupportKonto.WebFormShow(Sender: TObject);
begin
  xdsKontoSaldo.Close;
  xdsKontoSaldo.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer) ;
  xdsKontoSaldo.Load;
end;

procedure TSupportKonto.xdsKontoBewegungenAfterOpen(DataSet: TDataSet);
begin
  FormularAnzeigen;
end;

procedure TSupportKonto.xdsKontoSaldoAfterOpen(DataSet: TDataSet);
begin
  xdsKontoBewegungen.Close;
  xdsKontoBewegungen.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer)+'&$OrderBy=Datum' ;
  xdsKontoBewegungen.Load;
end;

procedure TSupportKonto.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  xdsKontoSaldo := TXDataWebDataSet.Create(Self);
  xdsKontoSaldoKundennummer := TStringField.Create(Self);
  xdsKontoSaldoZeitaufwand := TIntegerField.Create(Self);
  xdsKontoSaldoAbzurechnen := TIntegerField.Create(Self);
  xdsKontoSaldoGutschrift := TIntegerField.Create(Self);
  xdsKontoSaldoAbzug := TIntegerField.Create(Self);
  xdsKontoSaldoSaldo := TIntegerField.Create(Self);
  xdsKontoSaldoBetrag := TFloatField.Create(Self);
  xdsKontoSaldoMinutenpreis := TFloatField.Create(Self);
  xdsKontoSaldoSRestguthaben := TIntegerField.Create(Self);
  xdsKontoBewegungen := TXDataWebDataSet.Create(Self);
  xdsKontoBewegungenID := TIntegerField.Create(Self);
  xdsKontoBewegungenKundennummer := TStringField.Create(Self);
  xdsKontoBewegungenBuchungsart := TStringField.Create(Self);
  xdsKontoBewegungenLizenzID := TIntegerField.Create(Self);
  xdsKontoBewegungenTicketID := TIntegerField.Create(Self);
  xdsKontoBewegungenDatum := TDateTimeField.Create(Self);
  xdsKontoBewegungenZeitaufwand := TIntegerField.Create(Self);
  xdsKontoBewegungenAbzurechnen := TIntegerField.Create(Self);
  xdsKontoBewegungenGutschrift := TIntegerField.Create(Self);
  xdsKontoBewegungenAbzug := TIntegerField.Create(Self);
  xdsKontoBewegungenBetrag := TFloatField.Create(Self);
  xdsKontoBewegungenSaldo := TIntegerField.Create(Self);

  TC.BeforeLoadDFMValues;
  xdsKontoSaldo.BeforeLoadDFMValues;
  xdsKontoSaldoKundennummer.BeforeLoadDFMValues;
  xdsKontoSaldoZeitaufwand.BeforeLoadDFMValues;
  xdsKontoSaldoAbzurechnen.BeforeLoadDFMValues;
  xdsKontoSaldoGutschrift.BeforeLoadDFMValues;
  xdsKontoSaldoAbzug.BeforeLoadDFMValues;
  xdsKontoSaldoSaldo.BeforeLoadDFMValues;
  xdsKontoSaldoBetrag.BeforeLoadDFMValues;
  xdsKontoSaldoMinutenpreis.BeforeLoadDFMValues;
  xdsKontoSaldoSRestguthaben.BeforeLoadDFMValues;
  xdsKontoBewegungen.BeforeLoadDFMValues;
  xdsKontoBewegungenID.BeforeLoadDFMValues;
  xdsKontoBewegungenKundennummer.BeforeLoadDFMValues;
  xdsKontoBewegungenBuchungsart.BeforeLoadDFMValues;
  xdsKontoBewegungenLizenzID.BeforeLoadDFMValues;
  xdsKontoBewegungenTicketID.BeforeLoadDFMValues;
  xdsKontoBewegungenDatum.BeforeLoadDFMValues;
  xdsKontoBewegungenZeitaufwand.BeforeLoadDFMValues;
  xdsKontoBewegungenAbzurechnen.BeforeLoadDFMValues;
  xdsKontoBewegungenGutschrift.BeforeLoadDFMValues;
  xdsKontoBewegungenAbzug.BeforeLoadDFMValues;
  xdsKontoBewegungenBetrag.BeforeLoadDFMValues;
  xdsKontoBewegungenSaldo.BeforeLoadDFMValues;
  try
    Name := 'SupportKonto';
    Width := 209;
    Height := 480;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 209;
    TC.Height := 480;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.WidthStyle := ssPercent;
    TC.Align := alClient;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.Options.ScrollVertical := True;
    TC.WordWrap := True;
    TC.ColCount := 2;
    xdsKontoSaldo.SetParentComponent(Self);
    xdsKontoSaldo.Name := 'xdsKontoSaldo';
    xdsKontoSaldo.AfterOpen := xdsKontoSaldoAfterOpen;
    xdsKontoSaldo.EntitySetName := 'ITS_Kontosalden';
    xdsKontoSaldo.Connection := DM2.XDataWebConnection1;
    xdsKontoSaldo.Left := 32;
    xdsKontoSaldo.Top := 136;
    xdsKontoSaldoKundennummer.SetParentComponent(xdsKontoSaldo);
    xdsKontoSaldoKundennummer.Name := 'xdsKontoSaldoKundennummer';
    xdsKontoSaldoKundennummer.FieldName := 'Kundennummer';
    xdsKontoSaldoKundennummer.Required := True;
    xdsKontoSaldoKundennummer.Size := 13;
    xdsKontoSaldoZeitaufwand.SetParentComponent(xdsKontoSaldo);
    xdsKontoSaldoZeitaufwand.Name := 'xdsKontoSaldoZeitaufwand';
    xdsKontoSaldoZeitaufwand.FieldName := 'Zeitaufwand';
    xdsKontoSaldoAbzurechnen.SetParentComponent(xdsKontoSaldo);
    xdsKontoSaldoAbzurechnen.Name := 'xdsKontoSaldoAbzurechnen';
    xdsKontoSaldoAbzurechnen.FieldName := 'Abzurechnen';
    xdsKontoSaldoGutschrift.SetParentComponent(xdsKontoSaldo);
    xdsKontoSaldoGutschrift.Name := 'xdsKontoSaldoGutschrift';
    xdsKontoSaldoGutschrift.FieldName := 'Gutschrift';
    xdsKontoSaldoAbzug.SetParentComponent(xdsKontoSaldo);
    xdsKontoSaldoAbzug.Name := 'xdsKontoSaldoAbzug';
    xdsKontoSaldoAbzug.FieldName := 'Abzug';
    xdsKontoSaldoSaldo.SetParentComponent(xdsKontoSaldo);
    xdsKontoSaldoSaldo.Name := 'xdsKontoSaldoSaldo';
    xdsKontoSaldoSaldo.FieldName := 'Saldo';
    xdsKontoSaldoBetrag.SetParentComponent(xdsKontoSaldo);
    xdsKontoSaldoBetrag.Name := 'xdsKontoSaldoBetrag';
    xdsKontoSaldoBetrag.FieldName := 'Betrag';
    xdsKontoSaldoMinutenpreis.SetParentComponent(xdsKontoSaldo);
    xdsKontoSaldoMinutenpreis.Name := 'xdsKontoSaldoMinutenpreis';
    xdsKontoSaldoMinutenpreis.FieldName := 'Minutenpreis';
    xdsKontoSaldoSRestguthaben.SetParentComponent(xdsKontoSaldo);
    xdsKontoSaldoSRestguthaben.Name := 'xdsKontoSaldoSRestguthaben';
    xdsKontoSaldoSRestguthaben.FieldName := 'SRestguthaben';
    xdsKontoBewegungen.SetParentComponent(Self);
    xdsKontoBewegungen.Name := 'xdsKontoBewegungen';
    xdsKontoBewegungen.AfterOpen := xdsKontoBewegungenAfterOpen;
    xdsKontoBewegungen.EntitySetName := 'ITS_Kontobewegungen';
    xdsKontoBewegungen.Connection := DM2.XDataWebConnection1;
    xdsKontoBewegungen.Left := 32;
    xdsKontoBewegungen.Top := 216;
    xdsKontoBewegungenID.SetParentComponent(xdsKontoBewegungen);
    xdsKontoBewegungenID.Name := 'xdsKontoBewegungenID';
    xdsKontoBewegungenID.FieldName := 'ID';
    xdsKontoBewegungenID.Required := True;
    xdsKontoBewegungenKundennummer.SetParentComponent(xdsKontoBewegungen);
    xdsKontoBewegungenKundennummer.Name := 'xdsKontoBewegungenKundennummer';
    xdsKontoBewegungenKundennummer.FieldName := 'Kundennummer';
    xdsKontoBewegungenKundennummer.Size := 13;
    xdsKontoBewegungenBuchungsart.SetParentComponent(xdsKontoBewegungen);
    xdsKontoBewegungenBuchungsart.Name := 'xdsKontoBewegungenBuchungsart';
    xdsKontoBewegungenBuchungsart.FieldName := 'Buchungsart';
    xdsKontoBewegungenBuchungsart.Size := 25;
    xdsKontoBewegungenLizenzID.SetParentComponent(xdsKontoBewegungen);
    xdsKontoBewegungenLizenzID.Name := 'xdsKontoBewegungenLizenzID';
    xdsKontoBewegungenLizenzID.FieldName := 'LizenzID';
    xdsKontoBewegungenTicketID.SetParentComponent(xdsKontoBewegungen);
    xdsKontoBewegungenTicketID.Name := 'xdsKontoBewegungenTicketID';
    xdsKontoBewegungenTicketID.FieldName := 'TicketID';
    xdsKontoBewegungenDatum.SetParentComponent(xdsKontoBewegungen);
    xdsKontoBewegungenDatum.Name := 'xdsKontoBewegungenDatum';
    xdsKontoBewegungenDatum.FieldName := 'Datum';
    xdsKontoBewegungenZeitaufwand.SetParentComponent(xdsKontoBewegungen);
    xdsKontoBewegungenZeitaufwand.Name := 'xdsKontoBewegungenZeitaufwand';
    xdsKontoBewegungenZeitaufwand.FieldName := 'Zeitaufwand';
    xdsKontoBewegungenAbzurechnen.SetParentComponent(xdsKontoBewegungen);
    xdsKontoBewegungenAbzurechnen.Name := 'xdsKontoBewegungenAbzurechnen';
    xdsKontoBewegungenAbzurechnen.FieldName := 'Abzurechnen';
    xdsKontoBewegungenGutschrift.SetParentComponent(xdsKontoBewegungen);
    xdsKontoBewegungenGutschrift.Name := 'xdsKontoBewegungenGutschrift';
    xdsKontoBewegungenGutschrift.FieldName := 'Gutschrift';
    xdsKontoBewegungenAbzug.SetParentComponent(xdsKontoBewegungen);
    xdsKontoBewegungenAbzug.Name := 'xdsKontoBewegungenAbzug';
    xdsKontoBewegungenAbzug.FieldName := 'Abzug';
    xdsKontoBewegungenBetrag.SetParentComponent(xdsKontoBewegungen);
    xdsKontoBewegungenBetrag.Name := 'xdsKontoBewegungenBetrag';
    xdsKontoBewegungenBetrag.FieldName := 'Betrag';
    xdsKontoBewegungenSaldo.SetParentComponent(xdsKontoBewegungen);
    xdsKontoBewegungenSaldo.Name := 'xdsKontoBewegungenSaldo';
    xdsKontoBewegungenSaldo.FieldName := 'Saldo';
  finally
    TC.AfterLoadDFMValues;
    xdsKontoSaldo.AfterLoadDFMValues;
    xdsKontoSaldoKundennummer.AfterLoadDFMValues;
    xdsKontoSaldoZeitaufwand.AfterLoadDFMValues;
    xdsKontoSaldoAbzurechnen.AfterLoadDFMValues;
    xdsKontoSaldoGutschrift.AfterLoadDFMValues;
    xdsKontoSaldoAbzug.AfterLoadDFMValues;
    xdsKontoSaldoSaldo.AfterLoadDFMValues;
    xdsKontoSaldoBetrag.AfterLoadDFMValues;
    xdsKontoSaldoMinutenpreis.AfterLoadDFMValues;
    xdsKontoSaldoSRestguthaben.AfterLoadDFMValues;
    xdsKontoBewegungen.AfterLoadDFMValues;
    xdsKontoBewegungenID.AfterLoadDFMValues;
    xdsKontoBewegungenKundennummer.AfterLoadDFMValues;
    xdsKontoBewegungenBuchungsart.AfterLoadDFMValues;
    xdsKontoBewegungenLizenzID.AfterLoadDFMValues;
    xdsKontoBewegungenTicketID.AfterLoadDFMValues;
    xdsKontoBewegungenDatum.AfterLoadDFMValues;
    xdsKontoBewegungenZeitaufwand.AfterLoadDFMValues;
    xdsKontoBewegungenAbzurechnen.AfterLoadDFMValues;
    xdsKontoBewegungenGutschrift.AfterLoadDFMValues;
    xdsKontoBewegungenAbzug.AfterLoadDFMValues;
    xdsKontoBewegungenBetrag.AfterLoadDFMValues;
    xdsKontoBewegungenSaldo.AfterLoadDFMValues;
  end;
end;

end.